export enum ItemType {
  // Current types
  PHONE = 'Phone',
  COMPUTER = 'Computer',
  LAPTOP = 'Laptop',
  TABLET = 'Tablet',
  
  // Electronics & Technology
  GAMING_CONSOLE = 'GamingConsole',
  TV = 'TV',
  CAMERA = 'Camera',
  SMART_WATCH = 'SmartWatch',
  HEADPHONES = 'Headphones',
  DRONE = 'Drone',
  
  // Jewelry & Valuables
  JEWELRY = 'Jewelry',
  WATCH = 'Watch',
  ARTWORK = 'Artwork',
  ANTIQUE = 'Antique',
  DRINK = 'Drink',
  
  // Tools & Equipment
  POWER_TOOL = 'PowerTool',
  MUSICAL_INSTRUMENT = 'MusicalInstrument',
  SPORTS_EQUIPMENT = 'SportsEquipment',
  APPLIANCE = 'Appliance',
  
  // Documents & Media
  BOOK = 'Book',
  COLLECTIBLE = 'Collectible',

  // Assets
  CRYPTO = 'Crypto',

  // Catch-all
  OTHER = 'Other'
}
